<template>
  <div>
    <busy-indicator ref="main-busy-indicator"></busy-indicator>
    
    <div class="row">
      <div class="col-md-12">
        <div class="checkbox">
          <label>
            <input type="checkbox" @change="$emit(events.markWordsWithExampleSentances, $event)"> Mark words with available example sentances
          </label>
        </div>
      </div>
    </div>

    <div class="form-control" style="border:1px solid black; height: 500px; overflow-y:scroll">
      <div v-if="data.loaded">
        <ul>
          <li v-for="example in data.values" v-html="example">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap3";
import BusyIndicator from "./BusyIndicator";
import StoryProcessor from "../js/storyProcessor";
const machina = require("machina");

let events = {
  loaded: 'loaded',
  markWordsWithExampleSentances: 'markWordsWithExampleSentances'
};

export default {
  name: 'ExamplePhrasesWidget',
  inject: ["storyProcessor"],
  data: function(){
      return {
        state: undefined,
        events: events,

        data:{
          loaded: false,
          values: []
        }
      }
  },
  components: {
    "busy-indicator": BusyIndicator
  },
  created: function(){
    if (this.storyProcessor === undefined) {
      this.storyProcessor = new StoryProcessor();
    }
  },
  mounted: function(){
    var that = this;

    that.state = new machina.Fsm({
      initialState: "Loading",

      states: {
        Loading: {
          _onEnter: function() {
            that.$refs["main-busy-indicator"].showSpinner();
          },

          _onExit: function() {}
        },

        Loaded: {
          _onEnter: function() {
            that.$refs["main-busy-indicator"].hideAll();

            that.$emit(events.loaded);
          },

          _onExit: function() {}
        },

        LoadError: {
          _onEnter: function() {
            debugger;
            that.$refs["main-busy-indicator"].showError();
          },

          _onExit: function() {}
        }
      }
    });

    $.when(
      that.storyProcessor.loadSynonymsData()
    )
    .done(function() {
      that.state.transition("Loaded");
    })
    .fail(function() {
      that.state.transition("LoadError");
    });
  },
  methods: {
    /**
     * Clears loaded data
     */
    clearData: function(){
      this.data.loaded = false;
      this.data.values = [];
    },

    /**
     * Sets and returns example sentances for given word
     * @param {string} word Word for witch to return data
     * @returns {array} Array of example sentances of empty array if no examples exist
     */
    getExampleSentances: function(word){
      var dataToReturn = this.storyProcessor.getExampleSentances(word.toLowerCase());;

      let regex = new RegExp('\\b('+word+')\\b', 'gi');

      var dataToSet = dataToReturn.map(function(data){
        return data.replace(regex,"<b>$1</b>");
      });

      this.data.loaded = true;
      this.data.values = dataToSet;

      return dataToReturn;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExamplePhrasesWidget.vue